import { serializeURLSearchParamsStably } from './serializeURLSearchParamsStably';

/**
 * Assembles a listings URL from a finished path and the non-facet query params.
 *
 * The `path` is the complete path part (base path + taxonomy + `/-/` filters) as
 * produced by `@noths/polaris-product-listings-urls`'s `build`. This function only
 * appends the stable query string and an optional hash.
 */
export const buildListingsURL = (
  path: string,
  queryParams: URLSearchParams,
  hash?: string,
): string => {
  const query = serializeURLSearchParamsStably(queryParams);
  const normalizedHash = hash ?? '';
  return query ? `${path}?${query}${normalizedHash}` : `${path}${normalizedHash}`;
};
